import Vue from 'vue';

import GoogleAnalyticsChart from './components/Chart.vue';
import GoogleAnalyticsPeriodProvider from './components/PeriodProvider';

Vue.component('ga-chart', GoogleAnalyticsChart);
Vue.component('ga-period-provider', GoogleAnalyticsPeriodProvider);
